import { Add, Close, Upload } from "@mui/icons-material";
import {
  Box,
  Button,
  Card,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  FormLabel,
  ListItem,
  ListItemText,
  Radio,
  RadioGroup,
  TextareaAutosize,
  TextField,
  Typography,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { LoadingButton } from "@mui/lab";
import ShearingInstructions from "../../../admin/ShopSchedule/ShopCalendar/OrderItems/ShearingIndstructions";

const ShearInstructionsDialog = ({
  flatSheetSize,
  orderItem,
  open,
  onClose,
}) => {
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleClose = () => {
    // Reset and close
    onClose();
  };

  return (
    <Dialog
      fullWidth
      open={open}
      onClose={() => {
        if (!loading) {
          handleClose();
        }
      }}
    >
      <DialogTitle>Shearing Instructions</DialogTitle>
      <DialogContent>
        {
          // For some reason the extra_flats is a string "0.000" so will return a false positive if null checking
          orderItem.variables.extra_flats &&
          Number(orderItem.variables.extra_flats ?? 0) != 0 ? (
            <Box>
              <Typography
                variant="h6"
                component="div"
                sx={{ marginTop: "32px" }}
              >
                Shearing Instructions
              </Typography>
              <Typography>Not Available</Typography>
            </Box>
          ) : (
            <ShearingInstructions
              hideTitle={true}
              flatSheetSize={flatSheetSize}
              orderedCuts={
                orderItem.optimizerData
                  ? JSON.parse(orderItem.optimizerData).orderedCuts
                  : null
              }
              orderedPieces={
                orderItem.objectType == "TrimAndFlashing"
                  ? orderItem.trimPieces
                  : orderItem.objectType == "CopingCap"
                  ? orderItem.capPieces
                  : orderItem.cleatPieces
              }
            />
          )
        }
      </DialogContent>
      <Box
        sx={{
          m: 1,
          position: "relative",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {errorMessage && (
          <Box>
            <Typography color={"red"}>{errorMessage}</Typography>
          </Box>
        )}
      </Box>
      <DialogActions>
        <LoadingButton
          loading={loading}
          onClick={() => {
            if (!loading) handleClose();
          }}
        >
          Close
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default ShearInstructionsDialog;
